// Show Hide Price Section
document.addEventListener("DOMContentLoaded", function () {

    const buttons = document.querySelectorAll(".toggle-button-box a");
    const purchaseLicense = document.querySelector(".ios-iphone");
    const copyingCode = document.querySelector(".android-os");
    const enterCode = document.querySelector(".windows-os");
    const turningOn = document.querySelector(".mac-os");

    // Hide three-device by default (only inside this plan)
    if (copyingCode) {
      copyingCode.style.display = "none";
    }
    if (enterCode) {
      enterCode.style.display = "none";
    }
    if (turningOn) {
      turningOn.style.display = "none";
    }

    buttons.forEach(button => {
      button.addEventListener("click", function (e) {
        e.preventDefault();

        // Remove active class from buttons inside THIS plan only
        buttons.forEach(btn => btn.classList.remove("active"));

        // Add active to clicked button
        this.classList.add("active");

        // Get target section
        const targetClass = this.getAttribute("href").replace("#", "");

        // Toggle sections inside THIS plan only
        const targetSection = document.querySelector("." + targetClass);

        if (targetSection) {
          // Hide both first
          if (purchaseLicense) purchaseLicense.style.display = "none";
          if (copyingCode) copyingCode.style.display = "none";
          if (enterCode) enterCode.style.display = "none";
          if (turningOn) turningOn.style.display = "none";

          // Show selected
          targetSection.style.display = "block";
        }
      });
    });

});